import { daysInMonth, formatDateToCalendar } from '@/utils/index';

export const mustBePositive = val => val > 0;

export const mustBeZeroOrPositive = val => val >= 0;

export const mustBePositiveIfThereIsBalance = ((val, vm) => !(vm.isThereABalance === 'true' && val <= 0));

export const passwordValidation = ((val) => {
  const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[^\\w\\s])(?=.{6,})');
  return strongRegex.test(val);
});

export const dateValidation = ((val) => {
  if (val === null || val === '') {
    return true;
  }
  if (val.length < 8) {
    return false;
  }

  const [year, month, day] = formatDateToCalendar(val).split('-');
  const POSSIBLE_MONTHS_IN_YEAR = 12;
  const POSSIBLE_DAYS_IN_MONTH = daysInMonth(month, year);
  const NUMBERS_IN_YEAR = 4;

  return !(month > POSSIBLE_MONTHS_IN_YEAR || day > POSSIBLE_DAYS_IN_MONTH
    || year.length !== NUMBERS_IN_YEAR);
});

export const dateOfBirthValidation = ((val) => {
  if (val !== '' && val !== null) {
    const [year, month, date] = formatDateToCalendar(val).split('-');
    const maxPastDelta = 10;
    const maxYear = new Date().getFullYear() - maxPastDelta;
    const maxMonth = new Date().getMonth();
    const maxDate = new Date().getDate();
    const maxDateTime = new Date(maxYear, maxMonth, maxDate).getTime();
    const valDateTime = new Date(year, month - 1, date).getTime();

    return year >= 1900 && valDateTime <= maxDateTime;
  }
  return true;
});

export const mustBeTrue = (val => val);
